<template>
  <div class="jobsAdd">
    <el-form class="ruleForm" label-width="100px">
      <el-form-item label="公司名称">
           <el-input v-model="info.name"></el-input>
      </el-form-item>
      <el-form-item label="公司Logo">
          <MyUpload
            :dataSource="info.logo"

            @change="(url) => uploadImgSuccess(url, 'logo')"
          />
      </el-form-item>
      <el-form-item label="公司介绍">
           <el-input v-model="info.content" type="textarea" :rows="5"></el-input>
      </el-form-item>
      <el-form-item label="公司规模">
        <el-select v-model="info.scale_cn" placeholder="请选择公司规模" @change='selectScale'>
          <el-option v-for="(item,index) in scaleList" :key="index" :label="item.name" :value="[item.id,item.name]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="行业">
        <el-cascader v-model="info.trade" ref="cascaderRef" :options="tradeList" @change="changeTrade"
         :props="{ expandTrigger: 'hover', value: 'id', label: 'categoryname', children: 'data',}"></el-cascader>
      </el-form-item>
      <el-form-item label="公司地址">
           <el-input v-model="info.address"></el-input>
      </el-form-item>
      <el-form-item >
           <el-button  type="primary" @click="saveData()">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { Message } from "element-ui";
  import MyUpload from "@/components/upload/index";
  export default {
    components: {
      MyUpload,
    },
    data() {
      return {
        info:{
          logo:""
        },
        scaleList:[],
        tradeList:[]
      }
    },
    mounted() {
      this.getInfo()
      this.getCategory()
    },
    methods:{
      getInfo() {
        this.gets('architecture/getEnterpriseInfo').then(res=>{
          this.info = res.data.data
          this.info.trade=[this.info.first_trade,this.info.second_trade]
          this.info.trade_cn=[this.info.first_trade_cn,this.info.second_trade_cn]
        })
      },
      saveData() {
        this.post('architecture/updateEnterpriseInfo',this.info).then(res=>{
          if( res.data.code==1) {
             Message.success(res.data.msg)
          }else{
            Message.error(res.data.msg)
          }

        })
      },
      getCategory() {
        this.gets('category/indexpz').then(res => {
          let list = res.data.data
          this.scaleList = list.scale
          this.tradeList = list.newtrade
        })
      },
      selectScale(val){
        this.info.scale_cn = val[1]
        this.info.scale = val[0]
      },
      changeTrade(){
        this.info.trade_cn  = this.$refs["cascaderRef"].getCheckedNodes()[0].pathLabels
        this.info.first_trade = this.info.trade[0]
        this.info.second_trade = this.info.trade[1]
        this.info.first_trade_cn = this.info.trade_cn[0]
        this.info.second_trade_cn = this.info.trade_cn[1]
      },
      uploadImgSuccess(url, key) {
        this.info[key] = url;
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/entrepriseArchitecture/enterpriseInfo.vue